@if (searchable || multiple) {
  <s-form-autocomplete-text
    [label]="label"
    [groupName]="groupName"
    [fieldName]="fieldName"
    [form]="form"
    [defaultText]="defaultText"
    [items$]="multiple ? itemsForMulti$ : itemsForMulti$"
    [apiError]="apiError"
    [schema]="schema"
    [multiple]="multiple"
    [disabled]="disabled"
    displayProperty="name"
    (triggerChange)="triggerChange.emit($event)"
  />
} @else {
  <s-form-input-select
    [label]="label"
    [groupName]="groupName"
    [fieldName]="fieldName"
    [form]="form"
    [defaultText]="defaultText"
    [nonFormValue]="nonFormValue"
    [items$]="items$"
    [required]="isRequired()"
    [readonly]="readonly"
    [apiError]="apiError"
    [schema]="schema"
    [allowZero]="allowZero"
    [filter$]="filter$"
    [displayHint]="displayHint"
    [showClear]="showClear ?? !isRequired()"
    [enum]="true"
    [disabled]="disabled"
    (triggerChange)="triggerChange.emit($event)"
  />
}
